import * as actionTypes from "../actions/actionTypes";
import {
    clearUpdateRecordError,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    cancelUpdateRecord,
    cancelAddRecord,
    addRecordStart,
    addRecordSuccess,
    addRecordFail,
    clearAddRecordError,
    clearAddRecordLoading,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfList,
    updateInList,
    removeFromList,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LINKED_ACCOUNT_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_LINKED_ACCOUNT_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_LINKED_ACCOUNT_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_LINKED_ACCOUNT_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_LINKED_ACCOUNT_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_LINKED_ACCOUNT_LIST: return addToBottomOfList(state, action.payload);
        case actionTypes.UPDATE_IN_LINKED_ACCOUNT_LIST: return updateInList(state, action.payload);
        case actionTypes.REMOVE_FROM_LINKED_ACCOUNT_LIST: return removeFromList(state, action.payload);
        case actionTypes.FETCH_LINKED_ACCOUNT_START: return fetchRecordStart(state);
        case actionTypes.FETCH_LINKED_ACCOUNT_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_LINKED_ACCOUNT_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_LINKED_ACCOUNT: return clearRecord(state);
        case actionTypes.ADD_LINKED_ACCOUNT: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_LINKED_ACCOUNT_START: return addRecordStart(state);
        case actionTypes.ADD_LINKED_ACCOUNT_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_LINKED_ACCOUNT_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_LINKED_ACCOUNT_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_LINKED_ACCOUNT_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.UPDATE_LINKED_ACCOUNT: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_LINKED_ACCOUNT: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_LINKED_ACCOUNT_START: return updateRecordStart(state);
        case actionTypes.UPDATE_LINKED_ACCOUNT_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_LINKED_ACCOUNT_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_LINKED_ACCOUNT_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_LINKED_ACCOUNT_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.ADD_LINKED_ACCOUNT_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_LINKED_ACCOUNT_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_LINKED_ACCOUNT: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;